import { NSFunctions } from './utils/functions';
import { xCore } from './core';
import { NSMessages } from './utils/messages';
import { URN as NSURN } from './utils/urn';
import { NSDataModelInfo } from './data_model_info';
import { NSObjDetails } from './obj_details';
import { NSObjDetailsEdit } from './obj_details_edit';
import { NSUserFunctionPermissions } from './user_function_permissions';
  



export let NSObjDetailsCreate = {};

NSObjDetailsCreate.init = function()
{
    NSObjDetailsCreatePrivate.init();

    this.f_get_tree_button_create_HTML = 	        function () { return NSObjDetailsCreatePrivate.f_get_tree_button_create_HTML.apply( NSObjDetailsCreatePrivate, arguments ); };
    this.f_urn_is_for_creation = 	                function () { return NSObjDetailsCreatePrivate.f_urn_is_for_creation.apply( NSObjDetailsCreatePrivate, arguments ); };
    this.f_get_button_create_join_child_HTML_elem = function () { return NSObjDetailsCreatePrivate.f_get_button_create_join_child_HTML_elem.apply( NSObjDetailsCreatePrivate, arguments ); };


    
    this.reserved = {};
    this.reserved.o_buttons = {};
    this.reserved.o_buttons.f_button_click =        function () { return NSObjDetailsCreatePrivate.o_buttons.f_button_click.apply( NSObjDetailsCreatePrivate.o_buttons, arguments ); };
    
    
	this.objs ={};
	this.objs.LeafCreateButtonData = LeafCreateButtonData;

	window.NSObjDetailsCreate = NSObjDetailsCreate; //needed
	window.NSObjDetailsCreatePrivate_ = NSObjDetailsCreatePrivate;
}


const LeafCreateButtonData = class {
	constructor(elem_id, s_HTML, s_table_urn) {
	  this.elem_id = elem_id;
	  this.s_HTML = s_HTML;
	  this.s_table_urn = s_table_urn;
	}
  };


let NSObjDetailsCreatePrivate = 
{	

	
	private_objs: 
	{
		f_init: function()
		{

		},
		
		settings: null // settings from config

		
		
	},
	
	init: function()
	{
		var this_ = this;
		var private_objs = this.private_objs;
		
		private_objs.f_init();
		
		this.objs.init();
		
		
		//var moduleName = "NSObjDetailsCreatePrivate";
		//private_objs.settings = xCore.loader.modules[moduleName].settings;
		
		
	},
	
	f_creation_mode_is_active: function ()
	{

		var b_edit_section_is_active = NSObjDetailsEdit.f_edit_section_is_active();
		
		var s_urn = NSObjDetailsEdit.f_get_urn_of_obj_in_edition();
		
		var b_urn_is_for_creation = this.f_urn_is_for_creation(s_urn);
		
		var b_creation_mode_is_active = (b_edit_section_is_active && b_urn_is_for_creation)? true : false;
		
		return b_creation_mode_is_active;
	},
	
	/*
		o_in:
		{
			s_table_urn,
			s_urn_parent
			b_geometry_is_inherited,
			o_parent_geometry
		}		
	*/
	f_create_: function(o_in)
	{
		/*
			1 - load table data model info
			2 - create o_obj_details for new object
			3 - call object edition process
			
		*/
		var this_ = this;
		var s_table_urn = o_in.s_table_urn;
		var s_urn_parent = o_in.s_urn_parent;
		
		var f_cb = function (b_error, s_message)
		{
			if (b_error)
			{
				NSMessages.f_show_information(s_message);
				return;
			}
			
			/*
				o_in:
				{
					s_table_urn,
					s_urn_parent
					b_geometry_is_inherited,
					o_parent_geometry
				}		
			*/
			this_.f_create_part_2(o_in);
		}
		
	
        let o_promise = NSDataModelInfo.f_load_table____returning_promise({			
            b_full_info: true,
            s_table_urn: s_table_urn
        });

        o_promise
        .then(function(b_error, s_message) 
        {
            f_cb(b_error, s_message);
        })
        .catch(err => { 
            console.log(err);
        });
		
		
			
			
			
	},
	
	
	/*
		o_in:
		{
			s_table_urn,
			s_urn_parent,
			b_geometry_is_inherited,
			o_parent_geometry
		}		
	*/
	f_create_part_2: function(o_in)
	{
		var s_table_urn = o_in.s_table_urn;
		var s_urn_parent = o_in.s_urn_parent;
		var b_geometry_is_inherited = o_in.b_geometry_is_inherited;
		var o_parent_geometry = o_in.o_parent_geometry;
		var s_CONST_creation_record_key = this.f_get_creation_record_key_CONST();

		
		//creates urn for a record
        let s_urn = NSURN.f_create_record_urn_from_table_urn(s_table_urn , s_CONST_creation_record_key);
		
		
		/*
        			s_urn,
					bbox,
					feature,
					joined_object_counts,		
					b_is_icon,
					a_icon_size_xy	//[width, height]
        */
		var o_obj_details = new NSObjDetails.objs.ObjDetails(
			{
				s_urn: s_urn,
				bbox: {},
				feature: {
					id: s_urn,
					//name: s_collection_external_name,
					type: "Feature",
					properties: {},
					isNew : true,
				},
				joined_object_counts: {
                    a_fk_join_info: 		[],
                    a_external_join_info: 	[],
                    a_all_join_info: 		[]
                },
				b_geometry_is_inherited: b_geometry_is_inherited
			}
		);
			
		NSObjDetailsEdit.f_edit_details(o_obj_details, s_urn_parent, o_parent_geometry);
	},
	
	
	
	
	o_buttons: {
		
		//used to return button HTML string if user has permissions
		/**
			
			returns button HTML string (in an object of type {NSObjDetailsCreate.objs.LeafCreateButtonData) if user has permissions
			@returns {NSObjDetailsCreate.objs.LeafCreateButtonData}
		*/
		f_get_button_create_HTML: function(s_urn)
		{
			var s_HTML = "";
			let o_res_LeafCreateButtonData = new LeafCreateButtonData(null, s_HTML, null);
			
			var s_table_urn = s_urn;

            //AQUIIIIIIIIIIIII TO DO TODO
			//var b_user_has_permissions = true;//NSUserFunctionPermissions.f_has_permission_for_function_type_UPDATE_and_collection_urn(s_table_urn);
			let b_user_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_UPDATE_and_collection_urn(s_table_urn);
			
			if(b_user_has_permissions)
			{
				let s_guid = "TREE_BUTTON_CREATE__" + NSFunctions.guidGenerator();
				//s_HTML = '<button k_0="' + s_table_urn + '" type="button" class="btn btn-sm btn-danger" onclick="NSObjDetailsCreate.reserved.o_buttons.f_button_click(event, this);" ><img src="' + xCore.application.images_base_path + '/common/plus-lg_white.svg" alt="" width="16" height="16"></button>';
				s_HTML = '<button id="' + s_guid + '" k_0="' + s_table_urn + '" type="button" class="btn btn-sm btn-danger" ><img src="' + xCore.application.images_base_path + '/common/plus-lg_white.svg" alt="" width="16" height="16"></button>';
				o_res_LeafCreateButtonData.elem_id = s_guid;
				o_res_LeafCreateButtonData.s_HTML = s_HTML;
				o_res_LeafCreateButtonData.s_table_urn = s_table_urn;
			}
			
			//return s_HTML;
			return o_res_LeafCreateButtonData;
			
		},
		/*
			returns button HTML document element if the user has permissions
			
			o_in:
			{
				s_table_urn,		//	table urn on the child object to be created
				s_urn_parent		//  urn of parent object
				b_geometry_is_inherited,
				o_parent_geometry
			}
		*/
		f_get_button_create_join_child_HTML_elem: function(o_in)
		{
			var this_ = this;
			var s_table_urn = o_in.s_table_urn;

			let b_user_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_UPDATE_and_collection_urn(s_table_urn);
			
			var e_button;
			if(b_user_has_permissions)
			{
				e_button = document.createElement("button");
				e_button.setAttribute("type", "button");
				e_button.setAttribute("class", "btn btn-sm btn-danger");
				e_button.innerHTML = '<img src="' + xCore.application.images_base_path + '/common/plus-lg_white.svg" alt="" width="16" height="16"></img>';
				
				e_button.onclick = function(event)
				{
					this_.f_button_create_child_click(event, o_in);
				};
			}
			
			
			return e_button;
			
		},
		f_button_click: function(event, e_button)
		{
			var event_local = event || window.event;
			/*
				e.stopPropagation();
				For IE: window.event.cancelBubble = true
			
			*/
			event_local.stopPropagation();
			
			var s_table_urn = e_button.getAttribute("k_0");			
			
			/*
				o_in:
				{
					s_table_urn,
					s_urn_parent
				}		
			*/
			var o_in = {
				s_table_urn: s_table_urn,
				s_urn_parent: null
			}
			NSObjDetailsCreatePrivate.f_create_(o_in);
			
		},
		/*
		o_in:
		{
			s_table_urn,		//	table urn on the child object to be created
			s_urn_parent		//  urn of parent object
			b_geometry_is_inherited,
			o_parent_geometry
		}
		*/
		f_button_create_child_click: function(event, o_in)
		{	
			var event_local = event || window.event;
			/*
				e.stopPropagation();
				For IE: window.event.cancelBubble = true
			
			*/
			event_local.stopPropagation();
			
			
			var s_table_urn = o_in.s_table_urn;
			var s_urn_parent = o_in.s_urn_parent;
			var b_geometry_is_inherited = o_in.b_geometry_is_inherited;
			var o_parent_geometry = o_in.o_parent_geometry;

			
			/*
				o_in:
				{
					s_table_urn,
					s_urn_parent
				}		
			*/
			var o_in = {
				s_table_urn: s_table_urn,
				s_urn_parent: s_urn_parent,
				b_geometry_is_inherited: b_geometry_is_inherited,
				o_parent_geometry: o_parent_geometry
			}
			NSObjDetailsCreatePrivate.f_create_(o_in);
			
		},
		
	},
	
	// --------------------------------------------------------------------------------------------------------------
	//public functions:
	f_urn_is_for_creation: function(s_urn)
	{
		var b_record_is_for_creation;
		if(s_urn != null && s_urn != "")
		{
			var s_record_key = NSURN.f_get_urn_record_id(s_urn);
			
			var s_CONST_creation_record_key = this.f_get_creation_record_key_CONST();
			
			b_record_is_for_creation = (s_record_key == s_CONST_creation_record_key)? true : false;
			
		}
		else
		{
			b_record_is_for_creation = false;
		}
		
		
		return b_record_is_for_creation;
		
		
	},
	
	f_get_creation_record_key_CONST : function()
	{
		var s_CONST_creation_record_key = "____NEW____";
		
		return s_CONST_creation_record_key;
	},
	
	/*
		returns button HTML string if user has permissions
	*/
	f_get_tree_button_create_HTML: function(s_urn)
	{
		return this.o_buttons.f_get_button_create_HTML(s_urn);
	},
	
	/*
		returns button HTML string if user has permissions
	*/
	f_get_details_join_button_create_HTML: function(s_urn)
	{
		return this.o_buttons.f_get_button_create_HTML(s_urn);
	},
	
	/*
		returns button create joing child, document element if user has permissions
		
		o_in:
		{
			s_table_urn,		//	table urn on the child object to be created
			s_urn_parent		//  urn of parent object
		}
	*/
	f_get_button_create_join_child_HTML_elem: function(o_in)
	{
		return this.o_buttons.f_get_button_create_join_child_HTML_elem(o_in);
	},
	
	
	objs: {
		
		
		init: function()
		{
			
		}
		
	}
}

